export class AvatarColor {
    public nombre: string = '';
    public color: string = '';
}